import React from "react";

type LogoProps = {
  withWordmark?: boolean;
  size?: number; // icon height in px
  className?: string;
  color?: string; // hex or css color
};

/**
 * Helpr logo: chat bubble with home mark + optional wordmark
 */
const Logo: React.FC<LogoProps> = ({ withWordmark = true, size = 28, className, color = "#2563eb" }) => {
  return (
    <div className={className} style={{ display: "inline-flex", alignItems: "center", gap: withWordmark ? 10 : 0 }}>
      <svg
        role="img"
        aria-label="Helpr"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M48 8H20C13.373 8 8 13.373 8 20v18c0 6.627 5.373 12 12 12h10.667L36 56c.53.53 1.402.155 1.402-.595V50H48c6.627 0 12-5.373 12-12V20C60 13.373 54.627 8 48 8z"
          fill={color}
        />
        <path d="M22 40h20c1.105 0 2-.895 2-2V24c0-1.105-.895-2-2-2H22c-1.105 0-2 .895-2 2v14c0 1.105.895 2 2 2z" fill="#ffffff" opacity="0.0"/>
        <path d="M24 38h16a2 2 0 0 0 2-2v-8.8a2 2 0 0 0-.7-1.51l-8-6.4a2 2 0 0 0-2.6 0l-8 6.4a2 2 0 0 0-.7 1.51V36a2 2 0 0 0 2 2z" fill="#ffffff"/>
        <rect x="28" y="30" width="3" height="3" rx="0.5" fill={color} />
        <rect x="33" y="30" width="3" height="3" rx="0.5" fill={color} />
        <rect x="28" y="35" width="3" height="3" rx="0.5" fill={color} />
        <rect x="33" y="35" width="3" height="3" rx="0.5" fill={color} />
      </svg>
      {withWordmark && (
        <span style={{ fontWeight: 800, fontSize: Math.round(size * 0.9), lineHeight: 1, color }}>
          helpr
        </span>
      )}
    </div>
  );
};

export default Logo;


